import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as materiasService from '../../services/materias/materiasService';
import { classifyMateriasError } from '../../services/materias/materiasDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

function formatDictado(materiaCarreraDictado) {
  if (materiaCarreraDictado === '1') {
    return 'Primer Cuatrimestre';
  }
  if (materiaCarreraDictado === '2') {
    return 'Segundo Cuatrimestre';
  }
  return 'Anual';
}

export class LookupMaterias extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => materiasService.lookupMaterias(query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleMateriasError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWMaterias');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleMateriasError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(materias) {
    return (
      <table className="md-lookup__table md-lookup__table--materias" aria-label="Seleccionar la Materia">
        <thead>
          <tr>
            <th scope="col" className="md-lookup__col-code">Código</th>
            <th scope="col">Nombre</th>
            <th scope="col">Carrera</th>
            <th scope="col" className="md-lookup__col-anio-dictado">Año dictado</th>
            <th scope="col" className="md-lookup__col-periodo-dictado">Período de dictado</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {materias.map((materia) => (
            <tr key={materia.materiaCarreraCod}>
              <td className="md-lookup__col-code">{materia.materiaCarreraCodigo}</td>
              <td>{materia.materiaCarreraNombre}</td>
              <td>{materia.carreraNombre}</td>
              <td className="md-lookup__col-anio-dictado">{materia.materiaCarreraAnio}</td>
              <td className="md-lookup__col-periodo-dictado">{formatDictado(materia.materiaCarreraDictado)}</td>
              <LookupSelectButton
                onClick={() => this.handleItemSelect(
                  `${materia.materiaCarreraCod}%${materia.materiaCarreraCodigo}%${materia.materiaCarreraNombre}%${materia.carreraNombre}%${materia.materiaCarreraDictado}`
                )}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar la Materia"
        size="xl"
        dialogClassName="md-lookup__dialog md-lookup__dialog--materias"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese la materia o la carrera"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleMateriasError(error) {
    const outcome = classifyMateriasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleMateriasError(error);
    }
  }
}
